import React from "react";

const fetchSdlDataConfig = async () =>
  await fetch("/cmscontent", {
    method: "POST",
    body: JSON.stringify({
      query: `query{
        items(
          filter: {itemTypes: [COMPONENT], namespaceIds: [1],
          and: [{customMeta: {key: "ApplicationTag", value: "openpages"}}, {customMeta: {key: "ApplicationContentTag", value: "values"}},{
          customMeta: {key: "ApplicationPageTag", value: "foloPensionCalculator"}}]}
        ) {
          edges {
            node {
                ... on Component {
                content {
                    ... on UntypedContent {
                    data
                    }
                }
                }
            }
            }
        }
      }`,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response: Response) => {
      return response.json();
    })
    .catch((error) => {
      console.warn(error);
    });
export default fetchSdlDataConfig;
